<template>
  <div class="el-input el-input--suffix" :class="{'is-error': invalid, 'is-disabled': disabled}">
    <input
        type="text"
        autocomplete="off"
        class="el-input__inner"
        :value="formattedValue"
        :placeholder="placeholder"
        :max="max"
        :min="min"
        :style="{'textAlign': this.align}"
        @keypress="onKeyPress"
        @input="onInput"
        @change="onChange"
        @blur="onBlur"
        @focus="onFocus"
        :autofocus="autofocus"
        :disabled="disabled"
        :readonly="readonly"
    >
    <span class="el-input__suffix" v-if="suffixIconClass">
      <span class="el-input__suffix-inner">
        <i class="el-input__icon" :class="suffixIconClass"/>
      </span>
    </span>

  </div>
</template>

<script>
    import currency from '@/shared/filters/currency';

    export default {
        name: "NumericInput",
        props: {
            placeholder: String,
            value: [Number, String],
            min: {
                type: Number,
                default: -Infinity
            },
            max: {
                type: Number,
                default: Infinity
            },
            align: {
                type: String,
                default: 'left'
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            precision: {
                type: Number,
                default: 0
            },
            decimalSeparator: {
                type: String,
                default: '.'
            },
            thousandsSeparator: {
                type: String,
                default: ' '
            },
            allowNegative: {
                type: Boolean,
                default: false
            },
            invalid: {
              type: Boolean,
              default: false
            },
            clearable: {
              type: Boolean,
              default: false
            },
            suffixIconClass: {
              type: String,
              default: null
            }
        },
        data() {
            return {
                focused: false,
                formattedValue: null,
                digits: ['1','2','3','4','5','6','7','8','9','0']
            }
        },
        methods: {
            parseValue(event) {
                let value;
                if (event.target.value !== null && event.target.value !== undefined && event.target.value !== '' && event.target.value.length > 0) {
                    value = parseFloat(event.target.value.replace(new RegExp(this.thousandsSeparator, 'g'), ''));
                } else {
                    value = null;
                }
                return value;
            },
            onKeyPress(event) {
                const cursorPos = this.getCursorPosition(event.target);
                if (this.digits.includes(event.key) || (this.precision > 0 && event.key === this.decimalSeparator) || (this.allowNegative && cursorPos===0 && event.key === '-')) {
                    const value = event.target.value;
                    if (value !== null && value !== undefined && value.length > 0) {
                        if (value.includes(this.decimalSeparator)) {
                            if (event.key === this.decimalSeparator) {
                                event.preventDefault();
                            } else {
                                if (this.precision > 0) {
                                    const decimalSeparatorIndex = value.indexOf(this.decimalSeparator);
                                    if (decimalSeparatorIndex >= 0 && cursorPos > decimalSeparatorIndex) {
                                        const decimalValue = value.substring(decimalSeparatorIndex + 1);
                                        if (decimalValue && decimalValue.length >= this.precision) {
                                            event.preventDefault();
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    event.preventDefault();
                }
            },
            onInput(event) {
                let value = this.parseValue(event);
                if (this.max > 0 && value > this.max) {
                    value = this.max;
                } else if (value < this.min) {
                    value = this.min;
                }
                if ((this.value === null && value !== null) || (this.value !== null && value === null) || this.value !== value) {
                    // this.numericValue = value;
                    this.$emit('input', value);
                }
            },

            onChange(/*event*/) {
                this.$emit('change', this.value);
            },
            onBlur(event) {
                this.focused = false;
                if (this.value !== null && this.value !== undefined && this.value !== '') {
                    event.target.value = currency(this.value, '', this.precision, {thousandsSeparator: this.thousandsSeparator});
                } else {
                    event.target.value = '';
                }
            },
            onFocus(event) {
                this.focused = true;
                if (event.target.value && event.target.value.length > 0) {
                    event.target.value = this.parseValue(event);
                }
            },
            getCursorPosition(target) {
                let cursorPosition = 0;
                if (document && document.selection) {
                    target.focus();
                    const selRange = document.selection.createRange();
                    cursorPosition = selRange.text.length;
                } else if (target.selectionStart || target.selectionStart === '0') {
                    cursorPosition = target.selectionStart;
                }
                return cursorPosition;
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(val) {
                    if (!this.focused) {
                        if (val !== null && val !== undefined && val !== '') {
                            this.formattedValue = currency(val, '', this.precision, {thousandsSeparator: this.thousandsSeparator});
                        } else {
                            this.formattedValue = '';
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>